module.exports = __webpack_public_path__ + "img/top1.1f25f906.png";